/**
 * Crop Utility Functions
 * Helper functions for working with crop data and colors
 */

import { CROP_COLOR_MAP } from './_crop-colors';

/**
 * Get the color associated with a crop by its ID
 * @param cropName - Map of crop IDs to crop names
 * @param defaultColor - Default color to return if crop not found (default: '#4CAF50')
 * @returns Hex color string
 */
export function getCropColor(
  cropName:string,
  defaultColor: string = '#4CAF50'
): string {
  if (cropName) {
    return CROP_COLOR_MAP[cropName] || defaultColor;
  }
  return defaultColor;
}

/**
 * Get the color associated with a crop by its name directly
 * @param cropName - The crop name
 * @param defaultColor - Default color to return if crop not found (default: '#4CAF50')
 * @returns Hex color string
 */
export function getCropColorByName(
  cropName: string,
  defaultColor: string = '#4CAF50'
): string {
  return CROP_COLOR_MAP[cropName] || defaultColor;
}

/**
 * Check if a crop has a defined color
 * @param cropName - The crop name
 * @returns True if the crop has a defined color
 */
export function hasCropColor(cropName: string): boolean {
  return cropName in CROP_COLOR_MAP;
}

/**
 * Get all available crop names with their colors
 * @returns Record of crop names to their hex colors
 */
export function getAllCropColors(): { [key: string]: string } {
  return { ...CROP_COLOR_MAP };
}

